import OrdersPage from "./orders"

export default OrdersPage
